import axios from 'axios'
import router from '@/router'
const checkoutUrl = 'https://us-central1-videojuego-sh.cloudfunctions.net/createCheckout'

export default {

    async createCheckout(userId, email, productId) {
        try {
            const response = await axios.post(checkoutUrl, {
                userId,
                email,
                productId
            });
            console.log(response);
            return response.data;
        } catch (error) {
            console.log("Error", error);
            alert(error.toString());
            return null;
        }
    },
}